import React from 'react';
import { faPhoneAlt } from '@fortawesome/pro-solid-svg-icons/faPhoneAlt';

import PropTypes from 'prop-types';

import { Text, TextType } from 'ui-components/components/text';

import { ContactInfoField } from './contact-info-field';

import style from './contact-info-field.module.less';

export const PhoneNumber = ({ phoneNumber }) => {
  return (
    <ContactInfoField icon={faPhoneAlt}>
      <Text className={style['contact-info-field-value']} textType={TextType.Paragraph} title={phoneNumber} value={phoneNumber} />
    </ContactInfoField>
  );
};

PhoneNumber.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
};
